export default {
  roles(state) {
    return state.roles
  },
  permissions(state) {
    return state.permissions
  },
}
